import React from "react";
import notFoundImage from "../../assets/images/Ethiquin/not_found.png"; // Adjust the import path
import "./GlobalComponents.scss";
import { Box } from "@mui/material";

const NotFound = (props) => {
  return (
    <Box
      className="notfound"
      component="img"
      src={notFoundImage}
      alt="Not found"
      maxWidth={500}
      width="50%"
      display="block"
      textAlign="center"
      sx={{ objectFit: "contain", borderRadius: 4 }}
      {...props}
    />
  );
};

export default NotFound;
